import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import styled from 'styled-components';
import { Center, ColumnCenter } from '@/components/Flex';
import ImageSliderBelt from '@/components/ImageSliderBelt';
import BreakpointMobile from '@/components/breakpoint/BreakpointMobile';
import { IconTokenBfc } from '@/components/icons';
import LandingTitle from '@/components/text/LandingTitle';
import StyledText from '@/components/text/StyledText';
import { PARTNERS } from '@/configs/partners';
import useDeviceSize from '@/hooks/mobile/useDeviceSize';
import SectionHomePage from './SectionHomePage';

const Logo = styled.div`
  user-select: none;
`;

export default function PartnerSection() {
  // device size
  const deviceSize = useDeviceSize();

  // translate
  const { t } = useTranslation('home', {
    keyPrefix: 'partner',
  });

  // memo
  const partnersLengthDividedBy2 = useMemo(() => PARTNERS.length / 2, []);
  const partnersLengthDividedBy3 = useMemo(() => PARTNERS.length / 3, []);
  const partnersDividedBy2 = useMemo(
    () => [
      PARTNERS.slice(0, partnersLengthDividedBy2),
      PARTNERS.slice(partnersLengthDividedBy2),
    ],
    [partnersLengthDividedBy2]
  );
  const partnersDividedBy3 = useMemo(
    () => [
      PARTNERS.slice(0, partnersLengthDividedBy3),
      PARTNERS.slice(partnersLengthDividedBy3, partnersLengthDividedBy3 * 2),
      PARTNERS.slice(partnersLengthDividedBy3 * 2),
    ],
    [partnersLengthDividedBy3]
  );

  return (
    <SectionHomePage>
      <ColumnCenter $gap="xl">
        <Logo>
          <LandingTitle>
            <Center $gap="xxxs">
              <IconTokenBfc size={40} />
              <div>Bifrost</div>
            </Center>
          </LandingTitle>
        </Logo>
        <StyledText
          $fontSize="md"
          $fontWeight="regular"
          $color="secondary"
          $textAlign="center"
          $whiteSpace={deviceSize !== 'mobile' ? 'pre-wrap' : undefined}
        >
          {t('description')}
        </StyledText>
      </ColumnCenter>

      <BreakpointMobile>
        <ColumnCenter $gap="xxxl">
          {partnersDividedBy2.map((partners, partnersIndex) => (
            <Center $gap={71} key={partnersIndex}>
              <ImageSliderBelt items={partners.map(({ image }) => image)} />
            </Center>
          ))}
        </ColumnCenter>
      </BreakpointMobile>

      <BreakpointMobile reverse>
        <ColumnCenter $gap="xxxl">
          {partnersDividedBy3.map((partners, partnersIndex) => (
            <Center $gap={71} key={partnersIndex}>
              <ImageSliderBelt
                isReverse={partnersIndex % 2 === 1}
                items={partners.map(({ image }) => image)}
              />
            </Center>
          ))}
        </ColumnCenter>
      </BreakpointMobile>
    </SectionHomePage>
  );
}
